/* eslint-disable unicorn/numeric-separators-style */
import { StoryData } from '@cinch-nx/data-storyblok'
import { NewCarsOffersStory } from '../storyblok'

export const offerPageFallbackStory: StoryData<NewCarsOffersStory> = {
  name: 'new-cars-offers',
  parent_id: 1,
  created_at: '2026-02-05T09:43:32.914Z',
  published_at: '2026-02-16T00:11:32.977Z',
  id: 141701172934651,
  uuid: '5ea7bdfb-02d3-4500-af3f-621efab4f7f7',
  content: {
    SEO: [
      {
        _uid: '08ed00b3-3e2a-4d9d-a0cc-e1190abf58b7',
        HowTo: [],
        title: 'New car finance deals',
        robots: [],
        component: 'SEO',
        openGraph: [],
        description:
          'Find the latest new car finance deals at cinch, from 0% offers to deposit contributions. Choose from exciting brands with our new car offers now.',
        twitterCard: [],
        canonicalUrl: '',
      },
    ],
    _uid: 'c5a68e03-b65d-4a47-8002-0d4da88acfb6',
    body: [
      {
        _uid: 'de564ac6-4ea7-46e2-a49d-bb5516d9e7e5',
        text: {
          type: 'doc',
          content: [
            {
              type: 'paragraph',
              attrs: {
                textAlign: 'center',
              },
              content: [
                {
                  text: 'Explore the latest new car finance deals from some of the most exciting brands. Petrol, hybrid and electric, from hatchbacks to SUVs and everything in between.',
                  type: 'text',
                  marks: [
                    {
                      type: 'textStyle',
                      attrs: {
                        color: '',
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
        component: 'RichText',
      },
      {
        _uid: '351895ee-1c0b-4762-82c9-4b754a93b62d',
        cards: [
          {
            cta: [
              {
                url: '/enquiry?make=byd',
                _uid: '35b76b02-3881-4ca7-866b-7c1548316a04',
                type: 'secondary',
                label: 'Enquire now',
                component: 'CtaButton',
              },
            ],
            _uid: 'd979af98-cae5-4cae-a31e-493e3a0b256f',
            image: {
              id: 138203496534623,
              alt: '.',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename:
                'https://a.storyblok.com/f/143588/375x281/c5bd45e1c9/byd-dolphin-surf-offer-image.avif',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: '.',
                title: '',
                source: '',
                copyright: '',
              },
              is_external_url: false,
            },
            title: 'BYD DOLPHIN SURF (PCP)',
            banner: '1.9% APR Representative',
            component: 'FinanceOfferCard',
            footerText: 'Enquire for full finance details',
            offerDetail1: 'Available from £249 a month',
            offerDetail2: '£249 customer deposit',
            offerDetail3: '49-month agreement',
            offerDetail4: 'Offer ends 31 March 2026',
          },
          {
            cta: [
              {
                url: '/enquiry?make=byd',
                _uid: '688f725f-df04-4b09-b206-79cadb226af0',
                type: 'secondary',
                label: 'Enquire now',
                component: 'CtaButton',
              },
            ],
            _uid: '76a25407-299a-4efa-92d7-862f0f48dead',
            image: {
              id: 138203496534622,
              alt: '.',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename:
                'https://a.storyblok.com/f/143588/375x281/aebe183741/byd-dolphin-offer-image.avif',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: '.',
                title: '',
                source: '',
                copyright: '',
              },
              is_external_url: false,
            },
            title: 'BYD DOLPHIN (PCP)',
            banner: '1.9% APR Representative',
            component: 'FinanceOfferCard',
            footerText: 'Enquire for full finance details',
            offerDetail1: 'Available from £279 a month',
            offerDetail2: '£3,680 deposit contribution',
            offerDetail3: '49-month agreement',
            offerDetail4: 'Offer ends 31 March 2026',
          },
          {
            cta: [
              {
                url: '/enquiry?make=byd',
                _uid: '5277383d-a2bf-4c2b-91f7-80795f910156',
                type: 'secondary',
                label: 'Enquire now',
                component: 'CtaButton',
              },
            ],
            _uid: '909458a9-a15d-4fd6-89fc-1b1223c8d3fd',
            image: {
              id: 138203496489563,
              alt: '.',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename:
                'https://a.storyblok.com/f/143588/375x281/514522ec5f/byd-atto-2-offer-image.avif',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: '.',
                title: '',
                source: '',
                copyright: '',
              },
              is_external_url: false,
            },
            title: 'BYD ATTO 2 (PCP)',
            banner: '1.9% APR Representative',
            component: 'FinanceOfferCard',
            footerText: 'Enquire for full finance details',
            offerDetail1: 'Available from £369 a month',
            offerDetail2: '£1,600 deposit contribution',
            offerDetail3: '49-month agreement',
            offerDetail4: 'Offer ends 31 March 2026',
          },
          {
            cta: [
              {
                url: '/enquiry?make=byd',
                _uid: '1b2f9227-3121-4290-a389-87e4f61a5063',
                type: 'secondary',
                label: 'Enquire now',
                component: 'CtaButton',
              },
            ],
            _uid: '7fa8372d-dea2-426f-93dd-19242a6caf95',
            image: {
              id: 138203496505948,
              alt: '.',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename:
                'https://a.storyblok.com/f/143588/375x281/bb751fb890/byd-atto-3-offer-image.avif',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: '.',
                title: '',
                source: '',
                copyright: '',
              },
              is_external_url: false,
            },
            title: 'BYD ATTO 3 (PCP)',
            banner: '1.9% APR Representative',
            component: 'FinanceOfferCard',
            footerText: 'Enquire for full finance details',
            offerDetail1: 'Available from £399 a month',
            offerDetail2: '£6,070 deposit contribution',
            offerDetail3: '49-month agreement',
            offerDetail4: 'Offer ends 31 March 2026',
          },
          {
            cta: [
              {
                url: '/enquiry?make=byd',
                _uid: '4f6c4f12-2fbc-4911-9a2c-d02604a6078b',
                type: 'secondary',
                label: 'Enquire now',
                component: 'CtaButton',
              },
            ],
            _uid: 'd29a27e4-4e7b-4561-ba79-0a70451b45dd',
            image: {
              id: 138203496481370,
              alt: '.',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename:
                'https://a.storyblok.com/f/143588/600x450/66f4fa5ff9/byd-seal-offer-image.avif',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: '.',
                title: '',
                source: '',
                copyright: '',
              },
              is_external_url: false,
            },
            title: 'BYD SEAL (PCP)',
            banner: '1.9% APR Representative',
            component: 'FinanceOfferCard',
            footerText: 'Enquire for full finance details',
            offerDetail1: 'Available from £449 a month',
            offerDetail2: '£2,000 deposit contribution',
            offerDetail3: '49-month agreement',
            offerDetail4: 'Offer ends 31 March 2026',
          },
          {
            cta: [
              {
                url: '/enquiry?make=byd',
                _uid: '0fe8173d-72f1-434f-b528-b5d6ed49c2c6',
                type: 'secondary',
                label: 'Enquire now',
                component: 'CtaButton',
              },
            ],
            _uid: '1e1a5945-2773-4754-8005-5794a1abacef',
            image: {
              id: 138203496514141,
              alt: '.',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename:
                'https://a.storyblok.com/f/143588/375x281/71563c19e4/byd-seal-u-offer-image.avif',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: '.',
                title: '',
                source: '',
                copyright: '',
              },
              is_external_url: false,
            },
            title: 'BYD SEAL U DM-i (PCP)',
            banner: '2.9% APR Representative',
            component: 'FinanceOfferCard',
            footerText: 'Enquire for full finance details',
            offerDetail1: 'Available from £359 a month',
            offerDetail2: '£1,999 customer deposit',
            offerDetail3: '49-month agreement',
            offerDetail4: 'Offer ends 31 March 2026',
          },
          {
            cta: [
              {
                url: '/enquiry?make=byd',
                _uid: '48940958-7fc2-41f9-8043-b0e84b25c171',
                type: 'secondary',
                label: 'Enquire now',
                component: 'CtaButton',
              },
            ],
            _uid: 'a14e0b81-1f22-4730-980e-924784452c3f',
            image: {
              id: 138203496469080,
              alt: '.',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename:
                'https://a.storyblok.com/f/143588/375x281/b4aa5817a3/byd-sealion-5-offer-image.avif',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: '.',
                title: '',
                source: '',
                copyright: '',
              },
              is_external_url: false,
            },
            title: 'BYD SEALION 5 DM-i (PCP)',
            banner: '2.9% APR Representative',
            component: 'FinanceOfferCard',
            footerText: 'Enquire for full finance details',
            offerDetail1: 'Available from £299 a month',
            offerDetail2: '£1,525 deposit contribution',
            offerDetail3: '49-month agreement',
            offerDetail4: 'Offer ends 31 March 2026',
          },
          {
            cta: [
              {
                url: '/enquiry?make=byd',
                _uid: '855219d5-9323-4a1e-a8c8-30a545d8ed63',
                type: 'secondary',
                label: 'Enquire now',
                component: 'CtaButton',
              },
            ],
            _uid: 'f23ec7db-7548-461c-8c86-bd2998bc5fef',
            image: {
              id: 138203496477273,
              alt: '.',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename:
                'https://a.storyblok.com/f/143588/375x281/ff62974080/byd-seal-6-offer-image.avif',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: '.',
                title: '',
                source: '',
                copyright: '',
              },
              is_external_url: false,
            },
            title: 'BYD SEAL 6 DM-i (PCP)',
            banner: '2.9% APR Representative',
            component: 'FinanceOfferCard',
            footerText: 'Enquire for full finance details',
            offerDetail1: 'Available from £389 a month',
            offerDetail2: '£1,510 deposit contribution',
            offerDetail3: '49-month agreement',
            offerDetail4: 'Offer ends 31 March 2026',
          },
          {
            cta: [
              {
                url: '/enquiry?make=byd',
                _uid: 'cc81b455-4c2a-4749-8c61-1dd4885af654',
                type: 'secondary',
                label: 'Enquire now',
                component: 'CtaButton',
              },
            ],
            _uid: 'fb5c1487-29c0-4a5d-88f9-3aeb9f209a38',
            image: {
              id: 138203496444502,
              alt: '.',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename:
                'https://a.storyblok.com/f/143588/375x281/7964a563f1/byd-seal-6-touring-offer-image.avif',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: '.',
                title: '',
                source: '',
                copyright: '',
              },
              is_external_url: false,
            },
            title: 'BYD SEAL 6 TOURING DM-i (PCP)',
            banner: '2.9% APR Representative',
            component: 'FinanceOfferCard',
            footerText: 'Enquire for full finance details',
            offerDetail1: 'Available from £399 a month',
            offerDetail2: '£1,900 deposit contribution',
            offerDetail3: '49-month agreement',
            offerDetail4: 'Offer ends 31 March 2026',
          },
          {
            cta: [
              {
                url: '/enquiry?make=byd',
                _uid: '04b5000c-3f6e-4fdd-af64-c0896215ea4f',
                type: 'secondary',
                label: 'Enquire now',
                component: 'CtaButton',
              },
            ],
            _uid: '24cea4c8-ee62-450e-bd31-6285128555e1',
            image: {
              id: 138203496460887,
              alt: '.',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename:
                'https://a.storyblok.com/f/143588/375x281/e911eb422c/byd-sealion-7-offer-image.avif',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: '.',
                title: '',
                source: '',
                copyright: '',
              },
              is_external_url: false,
            },
            title: 'BYD SEALION 7 (PCP)',
            banner: '1.9% APR Representative',
            component: 'FinanceOfferCard',
            footerText: 'Enquire for full finance details',
            offerDetail1: 'Available from £479 a month',
            offerDetail2: '£1,550 deposit contribution',
            offerDetail3: '49-month agreement',
            offerDetail4: 'Offer ends 31 March 2026',
          },
        ],
        title: 'BYD Finance offers',
        component: 'FinanceOffersCarousel',
        disclaimer: 'Sold by our partner Marshall Motor Group',
        description: 'Save on a brand new BYD with our new car finance offers.',
        placeHolderImage: {
          id: 106719272958458,
          alt: 'Blue BYD Atto 3 SUV',
          name: '',
          focus: '',
          title: '',
          source: '',
          filename:
            'https://a.storyblok.com/f/132543/488x391/cb1fb17a27/byd-atto-3-2023-1.png',
          copyright: '',
          fieldtype: 'asset',
          meta_data: {
            alt: 'Blue BYD Atto 3 SUV',
            title: '',
            source: '',
            copyright: '',
          },
          is_external_url: false,
        },
        financeRepresentativeExample: ['8f5a2e9b-c045-4e94-b6e5-8a413d3dca98'],
      },
      {
        _uid: '5e13197c-1e28-459e-b428-8ecaedf9d2f8',
        cards: [
          {
            cta: [
              {
                url: '/enquiry?make=omoda',
                _uid: 'ba41dfee-5e8d-440b-8210-bbeb47a3b989',
                type: 'secondary',
                label: 'Enquire now',
                component: 'CtaButton',
              },
            ],
            _uid: '8f276bdf-ab25-47f6-82cc-4f496e2877e2',
            image: {
              id: 138896616612016,
              alt: 'OMODA 5 electric vehicle under red lighting',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename:
                'https://a.storyblok.com/f/143588/375x281/39a77ef744/omoda-5-offer-image.avif',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: 'OMODA 5 electric vehicle under red lighting',
                title: '',
                source: '',
                copyright: '',
              },
              is_external_url: false,
            },
            title: 'OMODA 5 (PCP)',
            banner: '0% APR Representative',
            component: 'FinanceOfferCard',
            footerText: 'Enquire for full finance details',
            offerDetail1: 'Available from £208.37 a month',
            offerDetail2: '£500 Test Drive Voucher',
            offerDetail3: '48-month agreement',
            offerDetail4: 'Offer ends 31 March 2026',
          },
          {
            cta: [
              {
                url: '/enquiry?make=omoda',
                _uid: 'fda0defd-836b-4e37-884d-778c4c989c60',
                type: 'secondary',
                label: 'Enquire now',
                component: 'CtaButton',
              },
            ],
            _uid: '8634966d-b2bc-4a18-bc52-910a77b53475',
            image: {
              id: 138896616853683,
              alt: 'OMODA E5 electric vehicle in white',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename:
                'https://a.storyblok.com/f/143588/600x450/a80b3efcca/omoda-e5-offer-image.avif',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: 'OMODA E5 electric vehicle in white',
                title: '',
                source: '',
                copyright: '',
              },
              is_external_url: false,
            },
            title: 'OMODA E5 (PCP)',
            banner: '0% APR Representative',
            component: 'FinanceOfferCard',
            footerText: 'Enquire for full finance details',
            offerDetail1: 'Available from £319 a month',
            offerDetail2: '£3,750 EV Grant',
            offerDetail3: '48-month agreement',
            offerDetail4: 'Offer ends 31 March 2026',
          },
          {
            cta: [
              {
                url: '/enquiry?make=omoda',
                _uid: '21293ba8-9b68-4348-b15e-46fe179e8218',
                type: 'secondary',
                label: 'Enquire now',
                component: 'CtaButton',
              },
            ],
            _uid: '8e197680-4e0e-4615-9e7d-4d0efefc8277',
            image: {
              id: 138898596405491,
              alt: 'OMODA 7 SUV in front of red neon lights',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename:
                'https://a.storyblok.com/f/143588/600x450/c55ce8a014/omoda-7-red-offer-image.webp',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: 'OMODA 7 SUV in front of red neon lights',
                title: '',
                source: '',
                copyright: '',
              },
              is_external_url: false,
            },
            title: 'OMODA 7 PHEV (PCP)',
            banner: '1.9% APR Representative',
            component: 'FinanceOfferCard',
            footerText: 'Enquire for full finance details',
            offerDetail1: 'Available from £348.97 a month',
            offerDetail2: '£4,278.56 customer deposit',
            offerDetail3: '48-month agreement',
            offerDetail4: 'Offer ends 31 March 2026',
          },
          {
            cta: [
              {
                url: '/enquiry?make=omoda',
                _uid: '5b269b70-9de1-48ff-95d0-468413dfbef9',
                type: 'secondary',
                label: 'Enquire now',
                component: 'CtaButton',
              },
            ],
            _uid: '74e0836a-f305-43de-a613-379ce39bf26b',
            image: {
              id: 138896616652977,
              alt: 'OMODA 9 SUV',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename:
                'https://a.storyblok.com/f/143588/375x281/f084da81ce/omoda-9-offer-image.avif',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: 'OMODA 9 SUV',
                title: '',
                source: '',
                copyright: '',
              },
              is_external_url: false,
            },
            title: 'OMODA 9 (PCP)',
            banner: '1.9% APR Representative',
            component: 'FinanceOfferCard',
            footerText: 'Enquire for full finance details',
            offerDetail1: 'Available from £498.98 a month',
            offerDetail2: '£500 Test Drive Voucher',
            offerDetail3: '48-month agreement',
            offerDetail4: 'Offer ends 31 March 2026',
          },
        ],
        title: 'OMODA Finance offers',
        component: 'FinanceOffersCarousel',
        disclaimer: 'Sold by our partner Marshall Motor Group',
        description: 'Make a new OMODA yours with our new car finance offers.',
        placeHolderImage: {
          id: 114849809829417,
          alt: 'Black OMODA 9 SUV driving on a rural road with grassy fields and trees under a cloudy sky.',
          name: '',
          focus: '',
          title: '',
          source: '',
          filename:
            'https://a.storyblok.com/f/143588/600x400/e642482561/omoda-9-model.jpg',
          copyright: '',
          fieldtype: 'asset',
          meta_data: {
            alt: 'Black OMODA 9 SUV driving on a rural road with grassy fields and trees under a cloudy sky.',
            title: '',
            source: '',
            copyright: '',
          },
          is_external_url: false,
        },
        financeRepresentativeExample: ['82749536-05cb-4532-9da9-20b2381f9345'],
      },
      {
        _uid: '2505af28-2cf3-4a8e-8027-b1e9ffe753ae',
        cards: [
          {
            cta: [
              {
                url: '/enquiry?make=jaecoo',
                _uid: '38ca79a5-fe2c-4937-ba0e-073688061ec8',
                type: 'secondary',
                label: 'Enquire now',
                component: 'CtaButton',
              },
            ],
            _uid: '68ef2c79-1d50-41ea-84bb-8d22c1261a8a',
            image: {
              id: 138995371606883,
              alt: 'JAECOO 5 SUV parked by a lake in the mountains',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename:
                'https://a.storyblok.com/f/143588/600x450/3f5bc92b2b/jaecoo-5-offer-image.webp',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: 'JAECOO 5 SUV parked by a lake in the mountains',
                title: '',
                source: '',
                copyright: '',
              },
              is_external_url: false,
            },
            title: 'JAECOO 5 (PCP)',
            banner: '3.9% APR Representative',
            component: 'FinanceOfferCard',
            footerText: 'Enquire for full finance details',
            offerDetail1: 'Available from £268.98 a month',
            offerDetail2: '£500 Test Drive Voucher',
            offerDetail3: '48-month agreement',
            offerDetail4: 'Offer ends 31 March 2026',
          },
          {
            cta: [
              {
                url: '/enquiry?make=jaecoo',
                _uid: 'aaa021e5-2c10-4b52-8b89-c43f0eb9dcc0',
                type: 'secondary',
                label: 'Enquire now',
                component: 'CtaButton',
              },
            ],
            _uid: '01ad2b99-731f-4bce-bb3a-214e9f15a14a',
            image: {
              id: 138994995094361,
              alt: 'JAECOO 5 EV parked by the side of a lake',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename:
                'https://a.storyblok.com/f/143588/600x450/017b71f68d/jaecoo-5-bev-offer-image.webp',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: 'JAECOO 5 EV parked by the side of a lake',
                title: '',
                source: '',
                copyright: '',
              },
              is_external_url: false,
            },
            title: 'JAECOO 5 BEV (PCP)',
            banner: '3.9% APR Representative',
            component: 'FinanceOfferCard',
            footerText: 'Enquire for full finance details',
            offerDetail1: 'Available from £368.99 a month',
            offerDetail2: '£3,151.36 customer deposit',
            offerDetail3: '48-month agreement',
            offerDetail4: 'Offer ends 31 March 2026',
          },
          {
            cta: [
              {
                url: '/enquiry?make=jaecoo',
                _uid: 'ba897893-edac-4379-aa03-73556a3e4b78',
                type: 'secondary',
                label: 'Enquire now',
                component: 'CtaButton',
              },
            ],
            _uid: '4251a2e7-31a1-48f9-af27-2b3e6eced761',
            image: {
              id: 138995167282016,
              alt: 'JAECOO 7 SUV in green driving down a mountain road',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename:
                'https://a.storyblok.com/f/143588/600x450/0ed8724f36/jaecoo-7-offer-image.webp',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: 'JAECOO 7 SUV in green driving down a mountain road',
                title: '',
                source: '',
                copyright: '',
              },
              is_external_url: false,
            },
            title: 'JAECOO 7 (PCP)',
            banner: '1.9% APR Representative',
            component: 'FinanceOfferCard',
            footerText: 'Enquire for full finance details',
            offerDetail1: 'Available from £348.99 a month',
            offerDetail2: '£500 Test Drive Voucher',
            offerDetail3: '48-month agreement',
            offerDetail4: 'Offer ends 31 March 2026',
          },
          {
            cta: [
              {
                url: '/enquiry?make=jaecoo',
                _uid: 'f61a8f11-4494-4400-941b-ff4c135651ae',
                type: 'secondary',
                label: 'Enquire now',
                component: 'CtaButton',
              },
            ],
            _uid: 'ce0f877d-4125-4432-8660-88ff0d66eb50',
            image: {
              id: 138994530603856,
              alt: 'JAECOO 7 SUV in silver driving along the coast',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename:
                'https://a.storyblok.com/f/143588/600x450/c0f62e2ec7/jaecoo-7-shs-offer-image.webp',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: 'JAECOO 7 SUV in silver driving along the coast',
                title: '',
                source: '',
                copyright: '',
              },
              is_external_url: false,
            },
            title: 'JAECOO 7 SHS (PCP)',
            banner: '0% APR Representative',
            component: 'FinanceOfferCard',
            footerText: 'Enquire for full finance details',
            offerDetail1: 'Available from £379.01 a month',
            offerDetail2: '£500 Test Drive Voucher',
            offerDetail3: '48-month agreement',
            offerDetail4: 'Offer ends 31 March 2026',
          },
        ],
        title: 'JAECOO Finance offers',
        component: 'FinanceOffersCarousel',
        disclaimer: 'Sold by our partner Marshall Motor Group',
        description:
          'Unlock great value on a new JAECOO with our new car finance offers.',
        placeHolderImage: {
          id: 116685895102265,
          alt: 'Green JAECOO 5 SUV driving down a country road',
          name: '',
          focus: '',
          title: '',
          source: '',
          filename:
            'https://a.storyblok.com/f/143588/600x400/36b9b0b4c2/jaecoo-5-model.webp',
          copyright: '',
          fieldtype: 'asset',
          meta_data: {
            alt: 'Green JAECOO 5 SUV driving down a country road',
            title: '',
            source: '',
            copyright: '',
          },
          is_external_url: false,
        },
        financeRepresentativeExample: ['8ad927dd-38b7-4d0d-8760-302c0243ecc5'],
      },
      {
        _uid: 'fb9f3e56-550a-42ea-8ca1-30f22a5dc43f',
        cards: [
          {
            cta: [
              {
                url: '/enquiry?make=chery',
                _uid: 'ddae444b-5254-429c-b831-043277f6811f',
                type: 'secondary',
                label: 'Enquire now',
                component: 'CtaButton',
              },
            ],
            _uid: 'f0ea5786-1183-43b4-a11c-bd06b8153cef',
            image: {
              id: 139691205426451,
              alt: 'Chery Tiggo 7 SUV in grey',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename:
                'https://a.storyblok.com/f/143588/1170x660/43b1996d13/tiggo-7-offer-image.jpeg',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: 'Chery Tiggo 7 SUV in grey',
                title: '',
                source: '',
                copyright: '',
              },
              is_external_url: false,
            },
            title: 'TIGGO 7 (PCP)',
            banner: '1.9% APR Representative',
            component: 'FinanceOfferCard',
            footerText: 'Enquire for full finance details',
            offerDetail1: 'Available from £248.97 a month',
            offerDetail2: '£4,443.78 customer deposit',
            offerDetail3: '48-month agreement',
            offerDetail4: 'Offer ends 31 March 2026',
          },
          {
            cta: [
              {
                url: '/enquiry?make=chery',
                _uid: '2e4558d5-1e27-4aa0-ac50-458c3b2a0860',
                type: 'secondary',
                label: 'Enquire now',
                component: 'CtaButton',
              },
            ],
            _uid: 'b171f6ac-6211-4cf3-b8e5-34569d540028',
            image: {
              id: 139691205381392,
              alt: 'Chery Tiggo 7 SUV in grey',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename:
                'https://a.storyblok.com/f/143588/714x400/67bf93edcc/tiggo-7-super-hybrid-offer-image.jpeg',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: 'Chery Tiggo 7 SUV in grey',
                title: '',
                source: '',
                copyright: '',
              },
              is_external_url: false,
            },
            title: 'TIGGO 7 PHEV (PCP)',
            banner: '0% APR Representative',
            component: 'FinanceOfferCard',
            footerText: 'Enquire for full finance details',
            offerDetail1: 'Available from £298.99 a month',
            offerDetail2: '£500 Test Drive Voucher',
            offerDetail3: '48-month agreement',
            offerDetail4: 'Offer ends 31 March 2026',
          },
          {
            cta: [
              {
                url: '/enquiry?make=chery',
                _uid: 'aa7926b3-073f-4f61-ba2c-ff4b1569396f',
                type: 'secondary',
                label: 'Enquire now',
                component: 'CtaButton',
              },
            ],
            _uid: 'ca6d72b3-9153-4fd1-83c5-91bd013d2409',
            image: {
              id: 139691205344527,
              alt: 'Chery Tiggo 8 SUV in green',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename:
                'https://a.storyblok.com/f/143588/714x400/948862df82/tiggo-8-offer-image.jpeg',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: 'Chery Tiggo 8 SUV in green',
                title: '',
                source: '',
                copyright: '',
              },
              is_external_url: false,
            },
            title: 'TIGGO 8 (PCP)',
            banner: '2.9% APR Representative',
            component: 'FinanceOfferCard',
            footerText: 'Enquire for full finance details',
            offerDetail1: 'Available from £377.19 a month',
            offerDetail2: '£2,132.04 customer deposit',
            offerDetail3: '48-month agreement',
            offerDetail4: 'Offer ends 31 March 2026',
          },
          {
            cta: [
              {
                url: '/enquiry?make=chery',
                _uid: '289aca9a-f593-4479-b9bd-0ea2a663d37e',
                type: 'secondary',
                label: 'Enquire now',
                component: 'CtaButton',
              },
            ],
            _uid: '13c78ebb-e23e-440f-a37e-7f68f272d882',
            image: {
              id: 139691205401874,
              alt: 'Chery Tiggo 8 Super Hybrid SUV in green',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename:
                'https://a.storyblok.com/f/143588/714x400/199be39b52/tiggo-8-super-hybrid-offer-image.webp',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: 'Chery Tiggo 8 Super Hybrid SUV in green',
                title: '',
                source: '',
                copyright: '',
              },
              is_external_url: false,
            },
            title: 'TIGGO 8 PHEV (PCP)',
            banner: '0% APR Representative',
            component: 'FinanceOfferCard',
            footerText: 'Enquire for full finance details',
            offerDetail1: 'Available from £359.12 a month',
            offerDetail2: '£350 Test Drive Voucher',
            offerDetail3: '48-month agreement',
            offerDetail4: 'Offer ends 31 March 2026',
          },
          {
            cta: [
              {
                url: '/enquiry?make=chery',
                _uid: '4be0e426-b68e-457f-9588-55e8cff1c1bb',
                type: 'secondary',
                label: 'Enquire now',
                component: 'CtaButton',
              },
            ],
            _uid: 'ab054d43-d822-426a-b8e0-a760d9285c2f',
            image: {
              id: 139691205397777,
              alt: 'Chery Tiggo 9 Super Hybrid SUV in green',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename:
                'https://a.storyblok.com/f/143588/714x400/67a7c54a39/tiggo-9-super-hybrid-offer-image.webp',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: 'Chery Tiggo 9 Super Hybrid SUV in green',
                title: '',
                source: '',
                copyright: '',
              },
              is_external_url: false,
            },
            title: 'TIGGO 9 PHEV (PCP)',
            banner: '3.9% APR Representative',
            component: 'FinanceOfferCard',
            footerText: 'Enquire for full finance details',
            offerDetail1: 'Available from £498.97 a month',
            offerDetail2: '£6,728.28 customer deposit',
            offerDetail3: '48-month agreement',
            offerDetail4: 'Offer ends 31 March 2026',
          },
        ],
        title: 'Chery Finance offers',
        component: 'FinanceOffersCarousel',
        disclaimer: 'Sold by our partner Marshall Motor Group',
        description:
          'Get behind the wheel of a new Chery with our new car finance offers.',
        placeHolderImage: {
          id: 121982403757033,
          alt: 'Chery Tiggo 9 SUV in grey',
          name: '',
          focus: '',
          title: '',
          source: '',
          filename:
            'https://a.storyblok.com/f/143588/712x400/846ecf976b/chery-tiggo-9-resize.jpg',
          copyright: '',
          fieldtype: 'asset',
          meta_data: {
            alt: 'Chery Tiggo 9 SUV in grey',
            title: '',
            source: '',
            copyright: '',
          },
          is_external_url: false,
        },
        financeRepresentativeExample: ['e0833abd-26fe-4873-b547-bde9bf628506'],
      },
      {
        _uid: 'ef771ce9-c145-4908-844b-1f78a4fb648d',
        faqs: [
          {
            _uid: '7cc4c71b-0bd2-4ee4-aa61-c3afbfc41802',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'Search our range of ',
                      type: 'text',
                    },
                    {
                      text: 'brand new cars',
                      type: 'text',
                      marks: [
                        {
                          type: 'link',
                          attrs: {
                            href: 'https://www.cinch.co.uk/new-cars',
                            uuid: null,
                            anchor: null,
                            target: '_self',
                            linktype: 'url',
                          },
                        },
                        {
                          type: 'underline',
                        },
                      ],
                    },
                    {
                      text: ', then submit our quick enquiry form and the Marshall team will call you back to discuss your purchase.',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'You can also visit our new car stores to discover some of the most exciting brands emerging in the UK.',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'cinch Chery:',
                      type: 'text',
                      marks: [
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'bullet_list',
                  content: [
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Chery Gatwick',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.cinch.co.uk/store/gatwick',
                                    uuid: null,
                                    anchor: null,
                                    target: '_self',
                                    linktype: 'url',
                                  },
                                },
                                {
                                  type: 'underline',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Chery Manchester',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.cinch.co.uk/store/chery-manchester',
                                    uuid: null,
                                    anchor: null,
                                    target: '_self',
                                    linktype: 'url',
                                  },
                                },
                                {
                                  type: 'underline',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Chery Medway',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.cinch.co.uk/store/chery-medway',
                                    uuid: null,
                                    anchor: null,
                                    target: '_self',
                                    linktype: 'url',
                                  },
                                },
                                {
                                  type: 'underline',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'cinch OMODA & JAECOO:',
                      type: 'text',
                      marks: [
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'bullet_list',
                  content: [
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'OMODA & JAECOO Bristol',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.cinch.co.uk/store/bristol',
                                    uuid: null,
                                    anchor: null,
                                    target: '_self',
                                    linktype: 'url',
                                  },
                                },
                                {
                                  type: 'underline',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'OMODA & JAECOO Manchester',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.cinch.co.uk/store/omoda-jaecoo-manchester',
                                    uuid: null,
                                    anchor: null,
                                    target: '_self',
                                    linktype: 'url',
                                  },
                                },
                                {
                                  type: 'underline',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'We’re partnering with Marshall Motor Group to bring our customers brand new cars.',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'Marshall has over 115 years of motoring know-how and is one of the UK’s largest motor retailers, so our customers benefit from the shared experience of both brands.',
                      type: 'text',
                    },
                  ],
                },
              ],
            },
            title: 'How can I buy a new car on cinch?',
            component: 'AccordionItem',
          },
          {
            _uid: '769b4705-2fe9-4b92-97a9-a4d2406bcc56',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'Of course, you can test drive new cars at the stores below. You’ll find addresses, opening hours and contact details when you click the relevant link.',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'Marshall BYD stores:',
                      type: 'text',
                      marks: [
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'bullet_list',
                  content: [
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Ashford',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.marshall.co.uk/byd/contact-us/marshall-byd-ashford/',
                                    uuid: null,
                                    anchor: null,
                                    target: '_self',
                                    linktype: 'url',
                                  },
                                },
                                {
                                  type: 'underline',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Canterbury',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.marshall.co.uk/byd/contact-us/marshall-byd-canterbury/',
                                    uuid: null,
                                    anchor: null,
                                    target: '_self',
                                    linktype: 'url',
                                  },
                                },
                                {
                                  type: 'underline',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Maidstone',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.marshall.co.uk/byd/contact-us/marshall-byd-maidstone/',
                                    uuid: null,
                                    anchor: null,
                                    target: '_self',
                                    linktype: 'url',
                                  },
                                },
                                {
                                  type: 'underline',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Northampton',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.marshall.co.uk/byd/contact-us/marshall-byd-northampton/',
                                    uuid: null,
                                    anchor: null,
                                    target: '_self',
                                    linktype: 'url',
                                  },
                                },
                                {
                                  type: 'underline',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Peterborough',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.marshall.co.uk/byd/contact-us/marshall-byd-peterborough/',
                                    uuid: null,
                                    anchor: null,
                                    target: '_self',
                                    linktype: 'url',
                                  },
                                },
                                {
                                  type: 'underline',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'St Neots',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.marshall.co.uk/byd/contact-us/marshall-byd-st-neots/',
                                    uuid: null,
                                    anchor: null,
                                    target: '_self',
                                    linktype: 'url',
                                  },
                                },
                                {
                                  type: 'underline',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'cinch Chery Stores:',
                      type: 'text',
                      marks: [
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'bullet_list',
                  content: [
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Gatwick',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.cinch.co.uk/store/gatwick',
                                    uuid: null,
                                    anchor: null,
                                    target: '_self',
                                    linktype: 'url',
                                  },
                                },
                                {
                                  type: 'underline',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Manchester',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.cinch.co.uk/store/chery-manchester',
                                    uuid: null,
                                    anchor: null,
                                    target: '_self',
                                    linktype: 'url',
                                  },
                                },
                                {
                                  type: 'underline',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Medway',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.cinch.co.uk/store/chery-medway',
                                    uuid: null,
                                    anchor: null,
                                    target: '_self',
                                    linktype: 'url',
                                  },
                                },
                                {
                                  type: 'underline',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'cinch OMODA & JAECOO Stores:',
                      type: 'text',
                      marks: [
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'bullet_list',
                  content: [
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Bristol',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.cinch.co.uk/store/bristol',
                                    uuid: null,
                                    anchor: null,
                                    target: '_self',
                                    linktype: 'url',
                                  },
                                },
                                {
                                  type: 'underline',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Manchester',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.cinch.co.uk/store/omoda-jaecoo-manchester',
                                    uuid: null,
                                    anchor: null,
                                    target: '_self',
                                    linktype: 'url',
                                  },
                                },
                                {
                                  type: 'underline',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            title: 'Can I test drive a new car from cinch?',
            component: 'AccordionItem',
          },
          {
            _uid: '2cd94a71-ea8d-4501-90c4-e799d701789e',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'You can pay for a new car however it suits you – buy outright or on finance (Hire Purchase or Personal Contract Purchase).',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'Since your purchase is handled by Marshall Motor Group, one of the UK’s largest motor retailers, they’ll talk you through your options after you submit your enquiry.',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            title: 'What are my payment options when buying a new car?',
            component: 'AccordionItem',
          },
          {
            _uid: 'aa897958-94a5-4698-bf6b-8c6b05d8d2bf',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'You get the full manufacturer warranty when you buy a new car. These can vary slightly between brands – the industry standard is three years/60,000 miles, while class-leading is up to seven years/100,000 miles.',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            title: 'What warranty do I get with a new car?',
            component: 'AccordionItem',
          },
          {
            _uid: '2c97625d-086e-4348-9ce6-0e633ed6d309',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'The Marshall team will talk you through your options for delivery and/or collection – and how long they’ll take – when they call you back after your enquiry.',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            title: 'How can I get my new car?',
            component: 'AccordionItem',
          },
          {
            _uid: 'd9b40a3e-19e0-454a-b21e-c44fa4d68b84',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'Of course. Browse our range of quality ',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                    {
                      text: 'used cars',
                      type: 'text',
                      marks: [
                        {
                          type: 'link',
                          attrs: {
                            href: 'https://www.cinch.co.uk/used-cars/',
                            uuid: null,
                            anchor: null,
                            target: '_self',
                            linktype: 'url',
                          },
                        },
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                    {
                      text: ' to find your perfect fit.',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            title: 'Can I buy a used car on cinch?',
            component: 'AccordionItem',
          },
        ],
        title: 'Frequently Asked Questions',
        component: 'FaqSection',
      },
    ],
    hero: [
      {
        _uid: 'b350b4ec-7356-4043-b3b6-6756e4cc75bf',
        logo: {
          id: null,
          alt: null,
          name: '',
          focus: null,
          title: null,
          source: null,
          filename: '',
          copyright: null,
          fieldtype: 'asset',
          meta_data: {},
        },
        image: {
          id: 144560937874267,
          alt: 'A silver JAECOO SUV underneath a glowing blue neon £ symbol',
          name: '',
          focus: '',
          title: '',
          source: '',
          filename:
            'https://a.storyblok.com/f/143588/600x400/3ba05bc49b/finance-offers-page-hero-silver.png',
          copyright: '',
          fieldtype: 'asset',
          meta_data: {
            alt: 'A silver JAECOO SUV underneath a glowing blue neon £ symbol',
            title: '',
            source: '',
            copyright: '',
          },
          is_external_url: false,
        },
        Button: [],
        heading: 'New car finance deals',
        component: 'HeroSection',
        logoCheck: false,
        subheading: 'Discover the best new car offers',
        imageLayout: 'Y',
      },
    ],
    component: 'LandingPage',
  },
  slug: 'new-cars-offers',
  full_slug: 'new-cars-offers',
  sort_by_date: null,
  position: -260,
  tag_list: [],
  is_startpage: false,
  meta_data: null,
  group_id: '0cacb124-0194-4d52-ad09-c7f8afb9a0a1',
  first_published_at: '2026-02-05T09:45:26.362Z',
  lang: 'default',
  alternates: [],
}
